import { generateId } from 'src/utils/traceIdGenerations';
import { supportPayload } from 'src/layouts/SidebarLayout/Header/help-box/interface/types';
import { get, post } from './mainApi';  

const leaveManagementServiceEndPoint = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;
const traceId = generateId(9);

export const sendSupportMessage = async (data: supportPayload) => {
  return post(`${leaveManagementServiceEndPoint}helpbox?traceId=${traceId}`, data);
};

export const getSupportSubjects = async () => {
  return get(`${leaveManagementServiceEndPoint}tab?traceId=${traceId}`);
};
